import React from "react";
import { useTranslation } from "react-i18next";
import { Form, SelectProps } from "semantic-ui-react";
import { EAuditStatus } from "../../../interfaces/IAudit";


interface AuditStatusSelectProps extends Omit<SelectProps, "onChange" | "value" | "options"> {
    value?: EAuditStatus
    onChange: (value?: EAuditStatus) => void;
};

export const AuditStatusSelect: React.FC<AuditStatusSelectProps> = ({
    onChange,
    value,
    ...selectProps
}) => {
    const { t } = useTranslation()
    const texts = {
        draft: t("Luonnos"),
        finished: t("Valmis")
    };

    const updateValue: SelectProps["onChange"] = (_1, { value }) => {
        onChange(value ? value as any : undefined);
    };

    return (
        <Form.Select
            options={[
                { value: EAuditStatus.Draft, text: texts.draft },
                { value: EAuditStatus.Finished, text: texts.finished }
            ]}
            value={value}
            onChange={updateValue}
            {...selectProps}
        />
    )
};
